var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('v-container',{staticClass:"default pa-0 background align-start",attrs:{"fluid":"","fill-height":""}},[_c('nuxt')],1)],1),_c('notification'),_c('dialogs',{ref:"dialogs"}),_c('e-new-version-informer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }